// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vz_a bhi_b bhi_wb"};